module.exports = __webpack_public_path__ + "static/1-b1b37fad65dfd157da75b90c61d02e1a.png";